(() => {
  if (window.__ggV7CollectionNav) return;
  window.__ggV7CollectionNav = true;

  const state = { loading: false, controller: null };

  const withPreview = (href) => {
    const target = new URL(href, window.location.origin);
    const current = new URL(window.location.href);
    if (target.pathname.replace(/\/$/, '') === '/collections/all' && !target.searchParams.has('sort_by')) {
      target.searchParams.set('sort_by', 'price-ascending');
    }
    const preview = current.searchParams.get('preview_theme_id');
    if (preview) target.searchParams.set('preview_theme_id', preview);
    return target;
  };

  const setLoading = (loading) => {
    state.loading = loading;
    document.documentElement.classList.toggle('v7-collection-loading', loading);
    document.querySelectorAll('[data-v7-collection-route], [data-v7-sort-link]').forEach((el) => {
      el.setAttribute('aria-busy', loading ? 'true' : 'false');
    });
  };

  const replaceNode = (selector, doc) => {
    const current = document.querySelector(selector);
    const next = doc.querySelector(selector);
    if (current && next) current.replaceWith(next);
  };

  const updateHeading = (doc) => {
    const current = document.querySelector('main h1') || document.querySelector('h1');
    const next = doc.querySelector('main h1') || doc.querySelector('h1');
    if (current && next) current.innerHTML = next.innerHTML;
  };

  const updatePage = (doc) => {
    updateHeading(doc);
    replaceNode('[data-v7-livestock-shell]', doc);
    replaceNode('.v7-shopping-toolbar', doc);
    replaceNode('collection-component', doc);
    document.title = doc.title || document.title;
  };

  const load = async (href, push = true) => {
    if (state.loading) return;
    const target = withPreview(href);
    if (target.origin !== window.location.origin) {
      window.location.href = target.toString();
      return;
    }

    if (state.controller) state.controller.abort();
    state.controller = new AbortController();
    setLoading(true);

    try {
      const response = await fetch(target.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: state.controller.signal
      });
      if (!response.ok) throw new Error('Collection request failed');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      if (!doc.querySelector('collection-component')) throw new Error('Collection content missing');

      updatePage(doc);

      if (push) {
        history.pushState({ ggV7Collection: true }, '', target.pathname + target.search);
      }

      const products = document.querySelector('collection-component');
      if (products) {
        const top = products.getBoundingClientRect().top + window.scrollY - 24;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      window.location.href = target.toString();
    } finally {
      setLoading(false);
    }
  };

  document.addEventListener('click', (event) => {
    const route = event.target.closest('[data-v7-collection-route]');
    if (route) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || route.target === '_blank') return;
      event.preventDefault();
      load(route.href, true);
      return;
    }

    const sort = event.target.closest('[data-v7-sort-link]');
    if (sort) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || sort.target === '_blank') return;
      event.preventDefault();
      load(sort.href, true);
    }
  });

  window.addEventListener('popstate', () => load(window.location.href, false));
})();